function checkForZeros(object) {
    let errors = {};
  
    for (let key in object) {
        if (!object[key]) {
            if (key == "weight") {
                errors.weight = 'place_weight_invalid_error';
            }
  
            else {
              errors.size = 'place_size_invalid_error';
            }
        }
    }
  
    return errors
  }
  
function checkForOverflow(object) {
    let errors = {};

    if (!object.width || object.width < 0.01 || object.width > 1000) {
        errors.width = 'place_width_invalid_error';
    }

    if (!object.length || object.length < 0.01 || object.length > 1000) {
        errors.length = 'place_width_invalid_error';
    }

    if (!object.height || object.height < 0.01 || object.height > 1000) {
        errors.height = 'place_width_invalid_error';
    }

    return errors
}

export default function validate(data) {
    let errors = {};

    if (!data.contract_number) {
        errors.contract_number = 'contract_number_error';
    }

    if (!data.cityFrom) {
        errors.cityFrom = 'cityFrom_error';
    }

    if (!data.cityTo) {
        errors.cityTo = 'cityTo_error';
    }

    if (!data.places) {
        errors.places = 'places_error';
    }

    data.places?.forEach((place, index) => {
        let place_errors = checkForZeros(place);
        let place_overflow = checkForOverflow(place);
    
        place_errors = {...place_errors, ...place_overflow}
    
        if (place_errors && Object.keys(place_errors).length) {
          errors[`places.${index}`] = place_errors;
        }
    
      })

    return errors
}